// GA4 ecommerce tracking (shop rebuild Phase 13)
const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag(...args);
};

export const ga4Item = (p, { size, quantity = 1, index } = {}) => ({
  item_id: p.sku || p.slug,
  item_name: p.seo_name || p.name,
  item_brand: "Ninja Run Club",
  item_category: p.primary_collection || (p.collections || [])[0] || "Apparel",
  ...(p.city ? { item_category2: p.city, item_category3: (p.gcat || "").includes("Hats") ? "Hat" : "Tee" } : {}),
  ...(size ? { item_variant: size } : {}),
  price: p.price,
  quantity,
  ...(index != null ? { index } : {}),
});

export const trackViewItemList = (products, listId, listName) =>
  gtag("event", "view_item_list", {
    item_list_id: listId,
    item_list_name: listName,
    items: products.filter((p) => p.price).slice(0, 40).map((p, i) => ga4Item(p, { index: i })),
  });

export const trackSelectItem = (p, listId, listName) =>
  gtag("event", "select_item", { item_list_id: listId, item_list_name: listName, items: [ga4Item(p)] });

export const trackViewItem = (p) =>
  gtag("event", "view_item", { currency: "USD", value: p.price, items: [ga4Item(p)] });

export const trackSelectSize = (p, size) =>
  gtag("event", "select_size", { currency: "USD", items: [ga4Item(p, { size })] });

export const trackBeginCheckout = (p, size, quantity = 1) =>
  gtag("event", "begin_checkout", { currency: "USD", value: (p.price || 0) * quantity, items: [ga4Item(p, { size, quantity })] });

export const trackBeginCheckoutBundle = (picks) =>
  gtag("event", "begin_checkout", {
    currency: "USD",
    value: 75,
    items: picks.map(({ p, size }, i) => ga4Item(p, { size, index: i })),
  });

export const trackPurchase = ({ sessionId, value, currency, productName, lookupKey, size, quantity }) => {
  const key = `nrc_purchase_${sessionId}`;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch {
    // sessionStorage unavailable (private mode) — proceed without dedupe
  }
  gtag("event", "purchase", {
    transaction_id: sessionId,
    value,
    currency: (currency || "usd").toUpperCase(),
    items: [{
      item_id: lookupKey,
      item_name: productName,
      item_brand: "Ninja Run Club",
      ...(size ? { item_variant: size } : {}),
      price: quantity ? value / quantity : value,
      quantity: quantity || 1,
    }],
  });
};

export const trackGenerateLead = (formId) => gtag("event", "generate_lead", { form_id: formId });
